import { toast } from "react-toastify";
import { axiosPrivate } from "../config";
import axios from "axios";

const forward = async ({ setActiveTab, id, status, setIsLoading }) => {
  try {
    setIsLoading(true);
    const res = await axiosPrivate.put(
      `/changeOrderStatus/${id}`,
      { status },
      {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      }
    );
    if (res.status === 200) {
      setActiveTab("Processing");
      toast.success("Transfered to Processing");
      setIsLoading(false);
    }
  } catch (error) {
    setIsLoading(false);
    console.log("Error:", error);
  }
};

const getOrdersByStatus = async ({status, pageSize, pageNumber}) => {
  const customer = await axiosPrivate.get(
    `/getOrders?limit=${pageSize}&page=${pageNumber}&status=${status}`
  );
  return customer?.data;
};

const getProfile = async (setAuth, setisLoader, navigate) =>
{
  try{
    const response = await axios.get(
      "/auth/profile",
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true
      }
    );  
    const profile = response.data.profile;
    const {name, email, role, avatar} = profile;
     setisLoader(false)
    setAuth({name, email, role, avatar});
    return {name, email, role, avatar};
  }catch(err){
    let message = err?.response?.data?.message;
    if(message = 'You are not logged in! Please log in to get access.')
    { 
      setisLoader(false)
      navigate('/login')
    }

    console.log("here is the errr-->> ", message)
  } 
}

export { forward, getOrdersByStatus ,getProfile};
